import React, { useState } from "react";
import { appendInquiry, errCode } from "../customerApi";
import { useMyText } from "./text";

const TEXT_MAX = 1000, PHOTO_MAX = 10, SIZE_MAX = 10 * 1024 * 1024, CAPTION_MAX = 50;
const IMG = /^image\/(jpeg|png|webp|gif)$/;
const CODES = ["text_required", "text_too_long", "not_an_image", "file_too_large", "too_many_attachments", "caption_too_long", "inquiry_closed"];

// 내용 덧붙이기(§14-1) — 열린 문의만. 화면이 막을 수 있는 것(빈 글·길이·장수·크기·형식)은 보내기 전에 막는다.
export default function AppendForm({ inquiry, onDone, onClosed }) {
    const tt = useMyText();
    const [text, setText] = useState("");
    const [photos, setPhotos] = useState([]); // [{file, caption, url}]
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);
    // 문의당 사진 합 10장 — 이미 붙은 사진과 지금 고른 사진을 뺀 만큼
    const left = Math.max(0, PHOTO_MAX - (inquiry.attachments?.length || 0) - photos.length);

    const add = (list) => {
        const files = [...(list || [])];
        if (!files.length) return;
        if (files.some((f) => !IMG.test(f.type))) { setErr(tt("err.not_an_image")); return; }
        if (files.some((f) => f.size > SIZE_MAX)) { setErr(tt("err.file_too_large")); return; }
        if (files.length > left) { setErr(tt("err.too_many_attachments")); return; }
        setErr("");
        setPhotos((p) => [...p, ...files.map((file) => ({ file, caption: "", url: URL.createObjectURL?.(file) || "" }))]);
    };
    const submit = async () => {
        const body = text.trim();
        if (!body) { setErr(tt("err.text_required")); return; }
        if (body.length > TEXT_MAX) { setErr(tt("err.text_too_long")); return; }
        if (photos.some((p) => p.caption.length > CAPTION_MAX)) { setErr(tt("err.caption_too_long")); return; }
        setBusy(true);
        setErr("");
        try {
            const out = await appendInquiry(inquiry.id, { text: body, files: photos.map((p) => p.file), captions: photos.map((p) => p.caption.trim()) });
            setText("");
            setPhotos([]);
            onDone(out);
        } catch (e) {
            const code = errCode(e);
            setErr(CODES.includes(code) ? tt(`err.${code}`) : tt("err.send"));
            if (code === "inquiry_closed") onClosed();
        }
        setBusy(false);
    };

    return (
        <div className="my-sec">
            <h3>{tt("append.title")}</h3>
            <textarea className="my-ta" aria-label={tt("append.title")} placeholder={tt("append.placeholder")} value={text}
                onChange={(e) => setText(e.target.value)} />
            <p className="my-hint">{tt("append.hint")}</p>
            {photos.length > 0 && (
                <div className="my-ap-list">
                    {photos.map((p, i) => (
                        <div key={i} className="my-ap-photo">
                            {p.url && <img src={p.url} alt="" />}
                            <input type="text" aria-label={tt("append.caption")} placeholder={tt("append.caption")} maxLength={CAPTION_MAX} value={p.caption}
                                onChange={(e) => setPhotos((all) => all.map((x, j) => (j === i ? { ...x, caption: e.target.value } : x)))} />
                            <button type="button" className="my-btn" onClick={() => setPhotos((all) => all.filter((_, j) => j !== i))}>{tt("append.remove")}</button>
                        </div>
                    ))}
                </div>
            )}
            {err && <p className="my-err" role="alert">{err}</p>}
            <div className="my-ap-act">
                {left > 0 && (
                    <label className="my-btn">
                        {tt("append.addPhoto", { left })}
                        <input type="file" accept="image/jpeg,image/png,image/webp,image/gif" multiple hidden
                            onChange={(e) => { add(e.target.files); e.target.value = ""; }} />
                    </label>
                )}
                <button type="button" className="my-btn pri" disabled={busy} onClick={submit}>{tt("append.submit")}</button>
            </div>
        </div>
    );
}
